import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2658d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tyres_patterns" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub_title" }, "All-ways. Go with you.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "TYRE PATTERNS", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw_500" }, " Kumho Tyre produces a wide range of tyres for cars, trucks, buses, and other vehicles. The company's tyres are known for their quality, performance, and durability. Kumho Tyre has completely focused on the development of “products that customers desire” from the planning stage to the development stage, as can be seen in the case of launching Majesty SOLUS, a premium tyre, and Eco-Wing S, an eco-friendly tyre. ", -1))

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_router_link, {
              to: { path: '/tyre-range' , hash: '#tyreRange'},
              class: "btn red_btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("VIEW OUR PATTERNS")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}